import { GetInitialDataCtx, WidgetProps } from "../../contracts/widget"
import { propertyCardWidgetConfig, PropertyCardWidgetConfig } from "./config"
import { WidgetProvider } from "../../providers/widget"
import { PropertyCardWidgetContent } from "./components/PropertyCardWidgetContent"
import "../../common/property-card/property-card.css"
// The Search Results template renders the explorer-look card; its class
// families (.hfse-property-* / .hk-*) come from the shared card stylesheet.
import "../../common/property-card/explorer-card.css"
import { useMemo } from "react"
import { parseWidgetConfig } from "@homerunner-next/widget-core/schema"

export const getInitialData = async ({ options, feedId, widgetId }: GetInitialDataCtx<PropertyCardWidgetConfig>) => {
    return {}
}

export default function PropertyCardWidget({ options, feedId, widgetId, resolvedTheme, data }: WidgetProps<PropertyCardWidgetConfig>) {
    const parsedOptions = useMemo(() => parseWidgetConfig(propertyCardWidgetConfig, options), [options])
    return (
        <WidgetProvider options={parsedOptions} feedId={feedId} widgetId={widgetId} resolvedTheme={resolvedTheme} widgetType="property-card" data={data ?? {}}>
            <PropertyCardWidgetContent />
        </WidgetProvider>
    )
}
